import { ExtendedAccountColumns } from '@/backend/features/contact-management/entities/extended-account/types';
import { ExtendedAccountFilterData } from '@/ui/features/contact-management/AccountsPanel/types';
import { AccountColumns } from '@juvare/contact-management/backend/features/accounts/shared';
import { findFilterValue, mapAccountFilterReverse } from '@juvare/contact-management/ui/features/groups/utils/mapAccountFilterReverse';
import { useOverrideMapCredentialingAccountFilter } from '@juvare/credentialing/ui/hooks/useOverrideMapCredentialingAccountFilter';
import { DynamicColumnDefinitions } from '@juvare/platform-sdk-react/ui/components/EntityTable/dynamicColumns';
import { Filter } from '@juvare/platform-shared/features/storage';

export const useOverrideMapAccountFilterReverse = () => {
    const { overrideMapCredentialingAccountFilterReverse } = useOverrideMapCredentialingAccountFilter();
    const overrideMapAccountFilterReverse = (
        filters: Filter<ExtendedAccountColumns>[],
        dynamicColumnData?: DynamicColumnDefinitions,
    ): ExtendedAccountFilterData => {
        const result: ExtendedAccountFilterData = {
            ...mapAccountFilterReverse(filters as Filter<AccountColumns>[], dynamicColumnData),
            ...overrideMapCredentialingAccountFilterReverse(filters as Filter<AccountColumns>[]),
        };

        if (filters.length > 0 && filters[0].metadata?.ui) {
            return filters[0].metadata.ui;
        }

        // @ts-expect-error findFilterValue does not accept sub-filter columns
        result.backgroundCheckType = findFilterValue(filters, 'backgroundCheckType', '=', 'string');
        // @ts-expect-error findFilterValue does not accept sub-filter columns
        result.backgroundCheckStatus = findFilterValue(filters, 'backgroundCheckStatus', 'in', 'array');

        result.esarVhpId = findFilterValue(filters, 'esarVhpId', '=', 'string');
        result.stateOfWork = findFilterValue(filters, 'stateOfWork', '=', 'string');

        return result;
    };

    return { overrideMapAccountFilterReverse };
};
